export default __webpack_public_path__ + "static/js/0.0ebdbab9.worker.js";